'use client';

import { useState } from 'react';
import { useDebounce } from 'react-use';
import { Button, Typography } from '@mui/material';
import { useIsMobile } from '@qb/frontend/hooks/mediaQueries';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
const ERROR_MESSAGE_QTY_ABOVE_STOCK = 'The quantity you’ve selected exceeds the stock availability. We will process your order, deliver available items and inform you about the lead time.';
export const CallToActionAddToCart = ({
  qty,
  stock,
  part,
  price: _price
}: Pick<PartDisplayDataResponse, 'part'> & {
  qty: number;
  price: number;
  stock: number;
}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const isMobile = useIsMobile();
  useDebounce(() => setErrorMessage(qty > stock && stock > 0 ? ERROR_MESSAGE_QTY_ABOVE_STOCK : ''), 200, [qty]);
  const isLoading = false;
  return <>
      {!!errorMessage && <Typography variant="bodySmallError" sx={{
      mb: [1, 1, 3],
      gridArea: '1 / 1 / 2 / 3'
    }}>
          {errorMessage}
        </Typography>}
      <Button fullWidth variant="contained" sx={{
      borderRadius: 100
    }} onClick={() => {
      window?.salesPilotPostMessages?.addToCart({
        qty,
        partID: part.id
      });
    }} loading={isLoading} data-sentry-element="Button" data-sentry-source-file="CallToActionAddToCart.tsx">
        Add to cart
      </Button>
      {!isMobile && <Button fullWidth variant="outlined" sx={{
      borderRadius: 100,
      mt: 1
    }} onClick={() => {
      window?.salesPilotPostMessages?.buyNow({
        qty,
        partID: part.id
      });
    }} loading={isLoading}>
          Buy now
        </Button>}
    </>;
};